export const FORM_INPUT_VALIDATION_MESSAGES: Record<string, string> = {
  maxlength: 'form.validation.errors.maxlength',
  minlength: 'form.validation.errors.minlength',
  required: 'form.validation.errors.required',
  email: 'form.validation.errors.email',
};
